import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container home-page" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_home_video = _resolveComponent("home-video")!
  const _component_home_map = _resolveComponent("home-map")!
  const _component_home_facebook = _resolveComponent("home-facebook")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_home_video),
    _createVNode(_component_home_map),
    _createVNode(_component_home_facebook)
  ]))
}